import loggedIn from '../../shared/loggedIn'
import user from '../../shared/user'

export const OPEN_MODAL = 'ksk001/loginModal/OPEN_MODAL'
export const CLOSE_MODAL = 'ksk001/loginModal/CLOSE_MODAL'

export const initialState = {
  isOpen: false,
  component: '',
  marketingType: '',
}

export default (state = initialState, action) => {
  const { type, payload, vermarktungsart } = action

  switch (type) {
    case OPEN_MODAL:
      return {
        ...state,
        isOpen: true,
        component: payload,
        marketingType: vermarktungsart,
      }
    case CLOSE_MODAL:
      return {
        ...state,
        isOpen: false,
        component: '',
      }
    default:
      return state
  }
}

export const openModal = (component, vermarktungsart = '') => (
  dispatch,
  getState
) => {
  if (component === 'unlockEstateAddress' || component === 'unlockOguloTour') {
    const state = getState()

    if (
      (!loggedIn || (loggedIn && !user.isFilled)) &&
      state.estatePage.estateData
    ) {
      const { permalink } = state.estatePage.estateData
      localStorage.setItem('lastUnlockEstateAddressRequest', permalink)
      localStorage.setItem('unlockReason', component)
    }
  }

  dispatch({
    type: OPEN_MODAL,
    payload: component ? component : '',
    vermarktungsart,
  })
}

export const closeModal = () => dispatch => {
  dispatch({
    type: CLOSE_MODAL,
  })
}
